"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "OverflowCarousel", {
  enumerable: true,
  get: function () {
    return _OverflowCarousel.OverflowCarousel;
  }
});
exports.default = void 0;
var _Carousel = _interopRequireDefault(require("./Carousel"));
var _OverflowCarousel = require("./OverflowCarousel");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = _Carousel.default;
exports.default = _default;